import { schema } from 'normalizr';

export const presenceSchema = new schema.Entity('presences');
